import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl/FormControl';

const styles = () => ({
  root: {
  },
});

const FullWidthFormControl = (props) => {
  const { classes, children, ...others } = props;
  return (
    <FormControl required fullWidth margin="dense" className={classes.root} {...others} >
      {children}
    </FormControl>
  );
};

FullWidthFormControl.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  children: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(styles)(FullWidthFormControl);
